import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'priorityFilter',
})
export class PriorityFilterPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    const isButtonStyle = args[0];
    if (isButtonStyle) {
      return this.getButtonStylePriority(value);
    }
    return this.getLabelStylePriority(value);
  }

  private getLabelStylePriority(priority: number) {
    const priorityStyles: { [key: number]: string } = {
      1: '#D2F1E0',
      2: '#F8F5DB',
      3: '#FBE1DB',
    };
    return priorityStyles[priority] || '';
  }

  private getButtonStylePriority(priority: number) {
    const priorityStyles: { [key: number]: string } = {
      1: '#73DCA2',
      2: '#F3EA92',
      3: '#F19884',
    };
    return priorityStyles[priority] || '';
  }

}
